angular.module('acme.view.application.orders.offline.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.offline',
  'acme.common.service.permissions',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.userPreferences',
  'acme.common.service.helpers'
]).controller('OfflineListController', OfflineListController);

/**
 * Controller responsible for managing the offline transactions list view
 * @class OfflineListController
 * @constructor
 * @param {Object} $scope - angular's $scope service
 * @param {Object} $state - angular's $state service
 * @param {Object} $uibModal - angular's $uibModal service
 * @param {Object} HelpersService - acme's HelpersService
 * @param {Object} OfflineService - acme's OfflineService
 * @param {Object} PermissionsService - acme's PermissionsService
 * @param {Object} GridStateFactory - acme's GridStateFactory
 * @param {Object} GridDefinitionFactory - acme's GridDefinitionFactory
 * @param {Object} UserPreferencesService - acme's UserPreferencesService
 * @return {OfflineListController} - Class instance
 */
function OfflineListController($scope, $state, $timeout, $filter, $uibModal, HelpersService, OfflineService, PermissionsService, GridStateFactory, GridDefinitionFactory, UserPreferencesService) {
  Object.assign(this, {
    $scope: $scope,
    $state: $state,
    $timeout: $timeout,
    $filter: $filter,
    $uibModal: $uibModal,
    HelpersService: HelpersService,
    OfflineService: OfflineService,
    PermissionsService: PermissionsService,
    GridStateFactory: GridStateFactory,
    GridDefinitionFactory: GridDefinitionFactory,
    UserPreferencesService: UserPreferencesService
  });
  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

/**
 * Angular lifecycle method $onInit
 * @public
 * @memberOf OfflineListController
 * @return {Undefined} -
 */
OfflineListController.prototype.$onInit = function () {
  this.vm = this._getVmOptions();
  this.filters = {
    FAILED: 'FAILED'
  };
  this.loading = false;
  this.onlyFailed = false;
  this.sortFields = {
    id: 'olid',
    status: 'ols',
    posUUID: 'olpu',
    updatedOn: 'olu',
    terminalId: 'oltid',
    createdOn: 'olc'
  };
  this.viewId = this.$state.current.name;
  this.offlineTransactionsListName = this.$state.current.name+'.grid0';
  this._fireEvents();

  this.gridState = new this.GridStateFactory();
  this.gridDefinition = new this.GridDefinitionFactory();

  this.gridDefinition.init(this.offlineTransactionsListName, this.vm, this.viewId, this.$state.current.data.enablePreferences);
  this.$scope.$on('DataGrid::UserPreferencesLoaded', this.refresh.bind(this));

};

/**
 * Loads the transactions into the view based on the query
 * @memberOf OfflineListController
 * @param {OfflineService.SearchQuery} query - Query to be passed to the offline service
 * @private
 * @return {Promise} -
 */
OfflineListController.prototype._load = function () {
  var getVm = this._getVm.bind(this),
    api = this.OfflineService,
    updateView = this._updateView.bind(this),
    query = this.gridState.getGridState();

  this.loading = true;
  return api.list(query)
    .then(getVm)
    .then(updateView)
    .catch(updateView);
};

/**
 * Get the ViewModel options based on the passed data
 * @memberOf OfflineListController
 * @private
 * @return {Object} - the viewModelOptions
 */
OfflineListController.prototype._getVmOptions = function () {
  var archive = this._archive.bind(this),
    detail = this._detail.bind(this),
    rerun = this._rerun.bind(this),
    paginate = this._paginate.bind(this),
    sort = this._sort.bind(this),
    columns = null;

  columns = this._buildColumns();

  return {
    rowHeight: 35,
    data: '$ctrl.vm.lines',
    appScopeProvider: {
      onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
        paginate(newPageNumber, newPageSize, sortField, sortDirection);
      },
      onDataGridSortChange: function(grid, columns, page) {
        sort(grid, columns, page);
      },
      onDblClick: function (item) {
        detail(item.entity);
      },
      detail: function (item) {
        detail(item.entity);
      },
      archive: function (item) {
        archive(item);
      },
      rerun: function (item) {
        rerun(item);
      }
    },
    columnDefs: columns
  };
};


/**
 * Process the ViewModel based on the passed data
 * @memberOf OfflineListController
 * @param {{list: Object, pagination: Object}} data - data to compute the vm
 * @private
 * @return {Object} - the viewModel
 */
OfflineListController.prototype._getVm = function (data) {
  var _data = data || {},
    status = this.status,
    // columns = null,
    pagination = null,
    lines = null;

  // columns = this._buildColumns();
  pagination = _data.pagination || {};
  lines = _data.list || [];

  return {
    // columns: columns,
    status: status,
    count: parseInt(pagination.count, 10) || 0,
    lines: lines
  };
};

/**
 * Sets the sorted properties and refreshes the view
 * @memberOf OfflineListController
 * @param {Object} grid - grid api object
 * @param {Array<Object>} columnData - Array with the sorted column
 * @private
 * @return {Undefined} -
 */
OfflineListController.prototype._sort = function (grid, columns, page) {
  var data = (columns instanceof Array && columns.length) ? columns[0] : {
    field: this.gridState.getPropertyValue('sortField'),
    sort: {
      direction: this.gridState.getPropertyValue('sortDirection')
    }
  };

  this.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
  this._load();
};

/**
 * Sets the paginations properties and refreshes the view
 * @memberOf OfflineListController
 * @param {Number} page - page number requested
 * @param {String} pageSize - number of items to display
 * @private
 * @return {Undefined} -
 */
OfflineListController.prototype._paginate = function (page, pageSize, sortField, sortDirection) {
  this.gridState.updateGridState(page, pageSize);
  if (sortField) {
    this.gridState.updateGridState(null, null, sortField, null);
  }
  if (sortDirection) {
    this.gridState.updateGridState(null, null, null, sortDirection);
  }
  this._load();
};

/**
 * Refreshes the view showing only the failed transactions
 * @memberOf OfflineListController
 * @public
 * @return {Undefined} -
 */
OfflineListController.prototype.showOnlyFailed = function () {
  this.onlyFailed = !this.onlyFailed;
  this.status = this.onlyFailed ? this.filters.FAILED : null;
  this.vm = Object.assign(this.vm, {
    status: this.status
  });
  this.refresh();
};

/**
 * Requests the server to retry every failed transaction
 * Then refreshes the view
 * @memberOf OfflineListController
 * @public
 * @return {Undefined} -
 */
OfflineListController.prototype.rerunAll = function () {
  var refresh = this.refresh.bind(this);

  this.OfflineService.rerun()
    .then(refresh);
};

/**
 * Refreshes the view
 * @memberOf OfflineListController
 * @public
 * @return {Undefined} -
 */
OfflineListController.prototype.refresh = function () {
  var props = this.gridDefinition.getGridState();
  this.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
  this._load();
};

/**
 * Opens a popup with the execution history
 * @memberOf OfflineListController
 * @param {Object} line - row data
 * @private
 * @return {Undefined} -
 */
OfflineListController.prototype._detail = function(line) {
  var refresh = this.refresh.bind(this);

  if (line) {
    this.$uibModal.open({
      templateUrl:
        'views/application/views/orders/offline/list/detail.tpl.html',
      size: 'lg',
      controller: 'OfflineDetailController',
      controllerAs: '$ctrl',
      resolve: {
        posUUID: function() {
          return line.posUUID;
        },
        orderNumber: function() {
          return line.orderNumber;
        },
        orderId: function() {
          return line.orderId;
        }
      }
    }).result.then(refresh);
  }
};

/**
 * Request the server to retry a failed transaction
 * Then refreshes the view
 * @memberOf OfflineListController
 * @param {Object} line - row data
 * @private
 * @return {Undefined} -
 */
OfflineListController.prototype._rerun = function (line) {
  var refresh = this.refresh.bind(this);

  if (line) {
    this.OfflineService.rerun([line.posUUID])
      .then(refresh);
  }
};

/**
 * Request the server to archive a failed transaction
 * Then refreshes the view
 * @memberOf OfflineListController
 * @param {Object} line - row data
 * @private
 * @return {Undefined} -
 */
OfflineListController.prototype._archive = function (line) {
  var refresh = this.refresh.bind(this);

  if (line) {
    this.OfflineService.archive(line.posUUID)
      .then(refresh);
  }
};

/**
 * Builds the colum definitions for the ag-grid
 * @memberOf OfflineListController
 * @private
 * @return {Array.<ColumnDefs>} - Column definitions
 */
OfflineListController.prototype._buildColumns = function () {
  var self = this,
    dateTimeFormat = self.UserPreferencesService.getDateTimeFormat('sortDateTime'),
    defaultColumns = [{
      displayName: 'View',
      field: 'detail',
      width: 60,
      onCellNavClick: function(row, col) {
        self._detail(row.entity);
      },
      cellTemplate: 'views/application/views/orders/offline/list/view-button.tpl.html',
      template: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a>View</a></div>',
      enableHiding: false,
      suppressSizeToFit: true,
      enableSorting: false,
      visible: true
    },{
      displayName: 'id',
      field: 'id',
      width: 80,
      visible: false
    }, {
      displayName: 'terminal id',
      field: 'terminalId',
      cellClass: 'offline-transactions-list-row-style'
    }, {
      displayName: 'order number',
      field: 'orderNumber',
      cellTemplate: '<div class="clickable ui-grid-cell-contents" ><a data-ui-sref="application.orders.detail.summary({ orderId: row.entity.orderId })">{{row.entity.orderNumber}}</a></div>'
    }, {
      displayName: 'order date/time',
      field: 'orderDate',
      cellFilter: 'date: "'+ dateTimeFormat +'"',
      cellFormatter: function(item) {
        return self.$filter('date')(item.value, dateTimeFormat);
      }
    }, {
      displayName: 'created on',
      field: 'createdOn',
      cellFilter: 'date: "'+ dateTimeFormat +'"',
      cellFormatter: function(item) {
        return self.$filter('date')(item.value, dateTimeFormat);
      },
      sort: {
        direction: 'asc'
      }
    }, {
      displayName: 'updated on',
      field: 'updatedOn',
      cellFilter: 'date: "'+ dateTimeFormat +'"',
      cellFormatter: function(item) {
        return self.$filter('date')(item.value, dateTimeFormat);
      }
    }, {
      displayName: 'pos uuid',
      field: 'posUUID',
      cellClass: 'offline-transactions-list-row-style',
      visible: false
    },
    {
      displayName: 'Type',
      field: 'transactionType'
    },
    {
      displayName: 'status',
      field: 'status',
      width: 120,
      onCellNavClick: function(row, col) {
        self._rerun(row.entity);
      },
      cellTemplate: 'views/application/views/orders/offline/list/rerun.tpl.html',
      cellRenderer: function(params) {
        var status = self.HelpersService.cap(params.data.status) || '',
            rerun = (status.toUpperCase() === self.filters.FAILED) ? '<a role="button"> (Re-run) </a>' : '';
        return '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">'+ status + rerun +'</div>';
      },
      enableHiding: false,
      enableSorting: false,
      visible: true
    }],
    archiveColumn = {
      displayName: 'actions',
      width: 120,
      field: 'archive',
      onCellNavClick: function(row, col) {
        self._archive(row.entity);
      },
      cellTemplate: 'views/application/views/orders/offline/list/archive.tpl.html',
      cellRenderer: function(params) {
        var status = params.data.status || '',
          archive = (status.toUpperCase() === self.filters.FAILED) ? '<a role="button" class="btn btn-sm btn-info offline-transactions-list-grid-btn"> Archive </a>' : '';
        return '<div class="text-center clickable ui-grid-cell-contents" ng-class="col.colIndex()">'+ archive +'</div>';
      },
      enableHiding: false,
      enableSorting: false,
      visible: true
    };

  if (this.PermissionsService.check('OFFLINE_TRANSACTIONS_ARCHIVE')) {
    defaultColumns.push(archiveColumn);
  }
  return defaultColumns;
};

/**
 * Broadcasts required events
 * @memberOf OfflineListController
 * @private
 * @return {Undefined} -
 */
OfflineListController.prototype._fireEvents = function () {
  var self = this;

  this.$scope.$emit('Application::contentTitleChange', {
    title: 'Offline Transactions',
    buttonLeft: null,
    buttonRight: {
      label: 'Re-run Failed Transactions',
      action: function() {
        self.rerunAll();
      }
    }
  });
};

/**
 * Updates the viewModel
 * @memberOf OfflineListController
 * @param {Object} vm - Object containing the data to update the public vm property
 * @private
 * @return {Undefined} -
 */
OfflineListController.prototype._updateView = function (vm) {
  var self = this;

  this.vm = Object.assign({}, this.vm, vm);
  this.loading = false;
  this.gridDefinition.isLoaded = true;
  this.$timeout(function() {
    self.$scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.vm.lines.length, totalItems: vm.count});
  }, 100);

};

OfflineListController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  '$uibModal',
  'HelpersService',
  'OfflineService',
  'PermissionsService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'UserPreferencesService'
];
